import React from 'react';
import 'core-js/features/string/replace-all';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';
import './index.scss';
// import ReactGA from 'react-ga';
import ReactGA from 'react-ga4';
import { createStore } from 'redux';
import rootReducer from './reducers';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import './language/i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; //PWA
import ReactPixel from 'react-facebook-pixel';
import TagManager from 'react-gtm-module';

// ReactPixel.init('285015764058286');

serviceWorkerRegistration.unregister();
// const TRACKING_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID; // 발급받은 추적ID를 환경 변수로 불러온다.

const GoogleTagManager = {
  gtmId: 'GTM-TV3Q4MH2',
};

TagManager.initialize(GoogleTagManager);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
if (!window.location.hostname.includes('localhost'))
  Sentry.init({
    dsn: 'https://f85d98c7de3455cd96dc29320bc45d77@sentry.shorton.kr/21',
    integrations: [new BrowserTracing()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    environment: 'WEB',
  });
const queryClient = new QueryClient();

const store = createStore(rootReducer);
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <App />
    </Provider>
  </QueryClientProvider>,
);
